
    // IMPORTS
    import { computed, defineComponent, PropType } from 'vue'
    import { buildDateFormatter } from '@/util'

    export default defineComponent({
        name: 'dateField',

        props: {
            value: { type: Object as PropType<Date>, required: false },
            format: { type: String as PropType<'datetime' | 'date' | 'time'>, required: false, default: () => 'datetime' },
            utc: { type: Boolean as PropType<boolean>, required: false, default: () => false }
        },

        setup(props) {
            /********************************************************************************************************************
             INIT
             ********************************************************************************************************************/

            /********************************************************************************************************************
             PUBLIC DATA
             ********************************************************************************************************************/
            const publicData = { }

            /********************************************************************************************************************
             COMPUTED DATA
             ********************************************************************************************************************/
            const renderValue = computed(() => formatDateTime(props.value))
            const computedData = { renderValue }

            /********************************************************************************************************************
             PUBLIC METHODS
             ********************************************************************************************************************/
            function formatDateTime(when?: Date): string {
                if (when == null) return ''

                const { formatDate, formatUtcDate, formatDateTime: fmtDT, formatUtcDateTime, formatTime, formatUtcTime } = buildDateFormatter()

                switch (props.format) {
                    case 'datetime': return props.utc ? formatUtcDateTime(when) : fmtDT(when)
                    case 'date':     return props.utc ? formatUtcDate(when) : formatDate(when)
                    case 'time':     return props.utc ? formatUtcTime(when) : formatTime(when)
                    default: return '<unknown format>'
                }
            }

            const publicMethods = { formatDateTime }

            /********************************************************************************************************************
             PRIVATE METHODS
             ********************************************************************************************************************/

            /********************************************************************************************************************
             LIFECYCLE HOOKS
             ********************************************************************************************************************/

            /********************************************************************************************************************
             COMPONENT INTERFACE
             ********************************************************************************************************************/
            return { ...publicData, ...computedData, ...publicMethods }
        }
    });
